import { TradeUploadWizardContext } from 'app/trade-upload-wizard/trade-upload-wizard.component';
import { SecondaryResource } from 'app/_resources/secondary.resource';
import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

class UploadWizardSummaryComponentCtrl implements ng.IController {
    public wizardCtrl: mgoAngularWizard.Wizard<TradeUploadWizardContext>;
    public submittedItems: string[];
    public submittedItemsErrors: string[];
    public errorMessages: string[];
    public successMessages: string[];

    constructor(
        private $log,
        private secondaryResource: SecondaryResource
    ) {}

    $onInit(): void {
        this.submittedItems = [];
        this.submittedItemsErrors = [];
        this.errorMessages = [];
        this.successMessages = [];
    }

    public checkSubmitTrades(trade) {
        let submitted = this.submittedItems;
        for (let entry of submitted) {
            if (entry === trade.id) {
                return true;
            }
        }
        return false;
    }

    public downloadXml(trade) {
        const payload = {
            id: trade.id,
            choice: this.wizardCtrl.context.choice,
            comment: this.wizardCtrl.context.comment
        };
        this.secondaryResource.generateXml(
            payload,
            (res: FallbackUploadResponseDto) => {
                this.$log.debug('XML generation for product data successful');
                this.provideXmlAsFileDownload(
                    res.responseXml,
                    'upload_' + trade.id
                );
            },
            (err) => {
                this.$log.error('XML generation for product data failed');
            }
        );
    }

    public provideXmlAsFileDownload(data, filename) {
        const blob = new Blob([data], { type: 'text/xml' });
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, filename);
        } else {
            const elem = window.document.createElement('a');
            elem.href = window.URL.createObjectURL(blob);
            elem.download = filename;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        }
    }

    public submitItem(trade) {
        const mappedData = {
            id: trade.id,
            choice: this.wizardCtrl.context.choice,
            comment: this.wizardCtrl.context.comment
        };

        return this.secondaryResource.save(
            mappedData,
            (res) => {
                //add trade to success list
                this.submittedItems.push(trade.id);
                this.successMessages.push(
                    this.getReadableChoice(this.wizardCtrl.context.choice) +
                        ' for ' +
                        this.getReadableType(trade.type) +
                        ' (ID: ' +
                        trade.id +
                        ') could be uploaded successfully.'
                );
            },
            (error) => {
                this.submittedItemsErrors.push(trade.id);
                if (error.data && error.data.message) {
                    this.errorMessages.push(error.data.message);
                } else {
                    this.errorMessages.push(
                        this.getReadableChoice(this.wizardCtrl.context.choice) +
                            ' for ' +
                            this.getReadableType(trade.type) +
                            ' (ID: ' +
                            trade.id +
                            ') could be not uploaded successfully.'
                    );
                }
            }
        ).$promise;
    }

    public getReadableType(type: String) {
        if (type === 'TRADE') {
            return 'trade';
        } else if (type === 'TRADE_PROPOSAL') {
            return 'trade proposal';
        }
    }

    public getReadableChoice(choice: SecondaryStatusChange) {
        if (choice === 'TRADE_ACCEPTANCE') {
            return 'Acceptance';
        } else if (choice === 'TRADE_REJECTION') {
            return 'Rejection';
        } else if (choice === 'TRADE_PROPOSAL_REJECTION') {
            return 'Rejection';
        }
    }
}

angular.module('app').component('pkpTradeUploadWizardSummary', {
    controller: UploadWizardSummaryComponentCtrl,
    require: {
        wizardCtrl: '^^wizard'
    },
    template:
        require('app/trade-upload-wizard/trade-upload-wizard-summary.component.html'),
    bindings: {}
});
